/** @format */

import {Trans} from 'react-i18next';

import {ArrowOutward} from '@mui/icons-material';

import {Root} from './styles';
import {generateLink} from '../helpers/generateLink';

interface Props {
  startDate: string;
  endDate: string;
}

const LogWidgetButton = ({startDate, endDate}: Props) => {
  return (
    <Root href={generateLink({startDate, endDate})} rel='noopener noreferrer' target='_blank'>
      <ArrowOutward fontSize='small' />
      <Trans>К логам</Trans>
    </Root>
  );
};

export {LogWidgetButton};
